import { GetDashboardStoriesMeta, GetDashboardStoriesPayload } from 'types/store/GetDashboardStories';
import { createAsyncReducer } from 'utils/Redux';

import { getDashboardStoriesActions } from '../actions';

export default createAsyncReducer<GetDashboardStoriesMeta, GetDashboardStoriesPayload>(getDashboardStoriesActions);
